import { CAT_USERS } from 'App/utils/Collections';

export default {
  category: CAT_USERS,
  filters: [],
  searchBarProp: 'name',
};
